export default __webpack_public_path__ + "static/media/3.1dd40262.png";